import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { searchEntities, type SearchParams } from '../../lib/api';
import { queryKeys } from './queryKeys';

export const useSearch = (token: string | null, projectId: string, params: SearchParams) => {
  return useQuery({
    queryKey: queryKeys.search.query(projectId, { q: params.q ?? '', types: params.types, limit: params.limit }),
    queryFn: () => searchEntities(token as string, projectId, params),
    enabled: Boolean(token) && projectId.length > 0 && (params.q?.length ?? 0) > 0,
    placeholderData: keepPreviousData,
  });
};

export const useSearchMeta = (token: string | null, projectId: string, enabled: boolean) => {
  return useQuery({
    queryKey: queryKeys.search.meta(projectId),
    queryFn: () => searchEntities(token as string, projectId, { q: '' }),
    enabled: enabled && Boolean(token) && projectId.length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
